export default __webpack_public_path__ + "static/media/burlywood-brown.90ace551.jpg";